import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { PeopleTableFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/ids/_layout/people/')({
  validateSearch: zodValidator(PeopleTableFilterSchema),
});
